
import createjs, { Point } from 'createjs-module'

import { Spots } from '../Spots'
import { Spot, SpotModelViewDto } from '../spot/Spot'

import * as Globals from '../../../../../globals'

import {
    FLYER_CANVAS_WIDTH,
    FLYER_CANVAS_HEIGHT,
} from '../../../../../globals'
import { Boundries } from '../../../../../globals/Boundries'

export class SpotsCollisionManager {
    
    constructor() {
        
    }

    isMinimalGridHasCollisions(mainContainer: Spots, mouseX: any, mouseY: any) {

        let minimalDimensions = mainContainer.spotsFunctions!.getNextGridMinimalDimensions(mainContainer.nextGgridSize!);

        // related to the current grid we are trying to add
        let left = mouseX;
        let right = mouseX + minimalDimensions.width
        let top = mouseY
        let bottom = mouseY + minimalDimensions.height

        let boundries1: Boundries = new Boundries();
        boundries1.init(left, right, top, bottom);

        let hasIntersections = false;


        for (let i = 0; i < mainContainer.innerSpots.length; i++) {
            const item = mainContainer.innerSpots[i];

            if (this.isInRangeHorizontally(boundries1, item.getBoundaries())) {
                if (this.isInRangeVertically(boundries1, item.getBoundaries())) {
                    hasIntersections = true;
                    break; 
                }
            }
        }

        if (!hasIntersections) {
            // test borders
            if (right > FLYER_CANVAS_WIDTH) {
                hasIntersections = true;
            }
            else if (bottom > FLYER_CANVAS_HEIGHT) {
                hasIntersections = true;
            }
        }

        return hasIntersections;
    }

    hasCollisionsBetweenSpots(selectedSpots: Spot[], otherSpots: Spot[]): boolean {

        let hasCollisions = false;

        for (let i = 0; i < selectedSpots.length; i++) {
            const selectedSpot = selectedSpots[i];
            
            for (let j = 0; j < otherSpots.length; j++) {
                const spot_j = otherSpots[j];

                if(spot_j !== selectedSpot) {

                    if (this.isInRangeHorizontally(selectedSpot.getBoundaries(), spot_j.getBoundaries())) {
                        if (this.isInRangeVertically(selectedSpot.getBoundaries(), spot_j.getBoundaries())) {
                            hasCollisions = true;

                            // for testing only
                            // this.isInRangeHorizontally(selectedSpot, spot_j)
                            // this.isInRangeVertically(selectedSpot, spot_j)

                            break; 
                        }
                    }

                    if(this.hasPassedAnyBorder(selectedSpot)){
                        hasCollisions = true;
                        break; 
                    }

                }
            }
        }
        

        return hasCollisions;
    }

    public hasPassedAnyBorder(spot: Spot) {
        
        let hasCollision = false;

        let left = spot.x
        let top = spot.y

        let right = spot.x + spot.getBounds().width
        let bottom = spot.y + spot.getBounds().height

        if(left < 0 || top < 0 || right > Globals.FLYER_CANVAS_WIDTH || bottom > Globals.FLYER_CANVAS_HEIGHT) {
            hasCollision = true;
        }

        return hasCollision
    }

    getBoundariesToRetriveToAvoidCanvasBorders(spot: Spot): Boundries {
        
        let left = spot.x
        let top = spot.y
        let right = spot.x + spot.getBounds().width
        let bottom = spot.y + spot.getBounds().height

        let correctionBoundries: Boundries = new Boundries()

        if(left < 0) {
            correctionBoundries.left = Math.abs(left)
        }

        if(top < 0) {
            correctionBoundries.top = Math.abs(top)
        }

        if(right > Globals.FLYER_CANVAS_WIDTH) {
            correctionBoundries.right = Math.abs(right - Globals.FLYER_CANVAS_WIDTH)
        }

        if(bottom > Globals.FLYER_CANVAS_HEIGHT) {
            correctionBoundries.bottom = Math.abs(bottom - Globals.FLYER_CANVAS_HEIGHT)
        }

        return correctionBoundries;
    }

    private isInRangeHorizontally(boundries1: Boundries, boundries2: Boundries){

        let left = boundries1.left!
        let right = boundries1.right!

        let left_i = boundries2.left!
        let right_i = boundries2.right!

        let success = false;

        if(left <= left_i && right >= right_i) {
            success = true;
        }
        else if(left <= left_i && right >= left_i && right <= right_i){
            success = true;
        }
        else if(left >= left_i && right <= right_i) {
            success = true;
        }
        else if(left >= left_i && left <= right_i && right >= right_i){
            success = true;
        }

        return success
    }

    private isInRangeVertically(boundries1: Boundries, boundries2: Boundries){

        let top = boundries1.top!
        let bottom = boundries1.bottom!

        let top_i = boundries2.top!
        let bottom_i = boundries2.bottom!

        let success = false;

        if(top <= top_i && bottom >= bottom_i) {
            success = true;
        }
        else if(top <= top_i && bottom >= top_i && bottom <= bottom_i){
            success = true;
        }
        else if(top >= top_i && bottom <= bottom_i) {
            success = true;
        }
        else if(top >= top_i && top <= bottom_i && bottom >= bottom_i){
            success = true;
        }

        return success
    }
    
    // private getInternalCollidedObjects(mainContainer: Spots, generatedWidth: number, generatedHeight: number) {

    //     let mouseX: number = mainContainer.mouseX0;
    //     let mouseY: number = mainContainer.mouseY0;

    //     // related to the current grid we are trying to add
    //     let left = mouseX;
    //     let right = mouseX + generatedWidth
    //     let top = mouseY
    //     let bottom = mouseY + generatedHeight

    //     let hasIntersections = false;
    //     let collidedObjects = [];

    //     console.log(`---------------------------------------------------`)
    //     console.log(`${left},${right},${top},${bottom}`)

    //     for (let i = 0; i < mainContainer.innerSpots.length; i++) {
    //         const item = mainContainer.innerSpots[i];

    //         if(item === mainContainer.currentSpotsContainer) {
    //             continue;
    //         }

    //         // current grid item that is already on screen
    //         let left_i = item.x;
    //         let right_i = item.x + item.getBounds().width
    //         let top_i = item.y
    //         let bottom_i = item.y + item.getBounds().height

    //         console.log(`${left_i},${right_i},${top_i},${bottom_i}`)

    //         //
    //         if (this.isInRangeHorizontally(mouseX, mouseY, generatedWidth, generatedHeight, item)) {
    //             if (this.isInRangeVertically(mouseX, mouseY, generatedWidth, generatedHeight, item)) {
    //                 hasIntersections = true; 
    //             }
    //         }

    //         if(hasIntersections) {
    //             hasIntersections = false;
    //             collidedObjects.push(item)
    //         }
    //     }

    //     /*
    //     if (!hasIntersections) {
    //         // test borders
    //         if (right2 > FLYER_CANVAS_WIDTH) {
    //             hasIntersections = true;
    //         }
    //         else if (bottom2 > FLYER_CANVAS_HEIGHT) {
    //             hasIntersections = true;
    //         }
    //     }
    //     */

    //     return collidedObjects;
    // }

    // private isInRangeHorizontally(x: number, y: number, width: number, height: number, item: createjs.Container){

    //     let left = x;
    //     let right = x + width
    //     let top = y
    //     let bottom = y + height

    //     let left_i = item.x;
    //     let right_i = item.x + item.getBounds().width
    //     let top_i = item.y
    //     let bottom_i = item.y + item.getBounds().height

    //     let success = false;

    //     if(left <= left_i && right >= right_i) {
    //         success = true;
    //     }
    //     else if(left <= left_i && right >= left_i && right <= right_i){
    //         success = true;
    //     }
    //     else if(left >= left_i && right <= right_i) {
    //         success = true;
    //     }
    //     else if(left >= left_i && left <= right_i && right >= right_i){
    //         success = true;
    //     }

    //     return success
    // }

    // private isInRangeVertically(x: number, y: number, width: number, height: number, item: createjs.Container){

    //     let left = x;
    //     let right = x + width
    //     let top = y
    //     let bottom = y + height

    //     let left_i = item.x;
    //     let right_i = item.x + item.getBounds().width
    //     let top_i = item.y
    //     let bottom_i = item.y + item.getBounds().height

    //     let success = false;

    //     if(top <= top_i && bottom >= bottom_i) {
    //         success = true;
    //     }
    //     else if(top <= top_i && bottom >= top_i && bottom <= bottom_i){
    //         success = true;
    //     }
    //     else if(top >= top_i && bottom <= bottom_i) {
    //         success = true;
    //     }
    //     else if(top >= top_i && top <= bottom_i && bottom >= bottom_i){
    //         success = true;
    //     }

    //     return success
    // }


    // private handleLiveScallingCollisions(mainContainer: Spots, mouseX: number, mouseY:number, collidedObjects: Spots[]) {

    //     let rightCollider = this.getNearestRightColliderObject(mainContainer, collidedObjects)
    //     let bottomCollider = this.getNearestBottomColliderObject(mainContainer, collidedObjects) 

    //     if(rightCollider) {
    //         mouseX = rightCollider.x;
    //     }
    //     else {
    //         this.reInitiRightCollidersState(mainContainer);
    //     }

    //     if(bottomCollider) {
    //         mouseY = bottomCollider.y;
    //     }
    //     else {
    //         this.reInitiLeftCollidersState(mainContainer);
    //     }


    //     return new Point(mouseX, mouseY)

    // }

    // getNearestRightColliderObject(mainContainer: Spots, collidedObjects: Spots[]){

    //     let smallestX = Number.MAX_VALUE

    //     let colliderToReturn: Spots | null = null;

    //     for (let i = 0; i < collidedObjects.length; i++) {
    //         const collider = collidedObjects[i];

    //         let lastChange = mainContainer.lastMouseX - collider.x
    //         let currentChange = mainContainer.currentMouseX - collider.x

    //         if(lastChange < 0 && currentChange >= 0) {
    //             // means that the right side has passed over the left side 
    //             collider.isRightCollider = true;
    //         }

    //         /*if(collider.isRightCollider) {
    //             if(lastChange >= 0 && currentChange < 0) {
    //                 // means that the right side has passed back before the left side 
    //                 collider.isRightCollider = false;
    //             }
    //         }*/

    //         console.log('------------------------------')
    //         console.log(mainContainer.lastMouseX, collider.x)
    //         console.log(mainContainer.currentMouseX, collider.x)
    //         console.log(lastChange)
    //         console.log(currentChange)

    //         if(collider.isRightCollider) {
    //             if(collider.x <= smallestX){
    //                 smallestX = collider.x;

    //                 if(colliderToReturn) {
    //                     colliderToReturn.isRightCollider = false;
    //                 }

    //                 colliderToReturn = collider;
    //             }
    //         }
    //     }

    //     return colliderToReturn;
    // }

    // getNearestBottomColliderObject(mainContainer: Spots, collidedObjects: Spots[]){

    //     let smallestY = Number.MAX_VALUE

    //     let colliderToReturn: Spots | null = null;

    //     for (let i = 0; i < collidedObjects.length; i++) {
    //         const collider = collidedObjects[i];

    //         let lastChange = mainContainer.lastMouseY - collider.y
    //         let currentChange = mainContainer.currentMouseY - collider.y

    //         if(lastChange < 0 && currentChange >= 0) {
    //             // means that the right side has passed over the left side 
    //             collider.isBottomCollider = true;
    //         }

    //         // if(collider.isBottomCollider) {
    //         //     if(lastChange >= 0 && currentChange < 0) {
    //         //         // means that the right side has passed back before the left side 
    //         //         collider.isBottomCollider = false;
    //         //     }
    //         // }

    //         if(collider.isBottomCollider) {
    //             if(collider.y <= smallestY){
    //                 smallestY = collider.y;

    //                 if(colliderToReturn) {
    //                     colliderToReturn.isBottomCollider = false;
    //                 }

    //                 colliderToReturn = collider;
    //             }
    //         }   
    //     }

    //     return colliderToReturn;
    // }

    public reInitiRightCollidersState(mainContainer: Spots){
        for (let i = 0; i < mainContainer.innerSpots.length; i++) {
            const element = mainContainer.innerSpots[i];
            // element.isRightCollider = false;
        }
    }

    public reInitiLeftCollidersState(mainContainer: Spots){
        for (let i = 0; i < mainContainer.innerSpots.length; i++) {
            const element = mainContainer.innerSpots[i];
            // element.isBottomCollider = false;
        }
    }

    public normalizeScallings(
        mainContainer: Spots, 
        spotModelViewDto: SpotModelViewDto, 
        nextScaleX: number, 
        nextScaleY: number): createjs.Point
        {

        const spot = spotModelViewDto.spot!
        const spotDto = spotModelViewDto.dto!;

        let miniamlDimensions = mainContainer.spotsFunctions!.getNextGridMinimalDimensions(new Point(1, 1))

        let nextWidth = spot.originalWidth * nextScaleX;
        let nextHeight = spot.originalHeight * nextScaleY;
        
        if (nextWidth <= miniamlDimensions.width!) {
            nextScaleX = miniamlDimensions.width! / spotDto.fpsWidthPx!
        }
        if (nextHeight <= miniamlDimensions.height!) {
            nextScaleY = miniamlDimensions.height! / spotDto.fpsHeightPx!
        }

        return new Point(nextScaleX, nextScaleY)
    }
}